import EditBill from '../../../bills/components/EditBill';

export default function EditBillScreen() {
    return <EditBill />;
}
